<template>
    <div class="p-grid p-mx-auto">
        <div class="p-col-12 p-md-8 p-mx-auto p-text-left p-mt-4">
            <Dropdown class="p-col-12 p-md-6" placeholder="Select Team"
                v-model="myTeam.ssTeamId"
                @change="getMyTeamData()"
                :options="teams.items" :loading="myTeam.loading"
                optionLabel="name" optionValue="ss_team_id" />
        </div>

        <div class="p-col-12 p-md-10 p-mx-auto"
            v-show="!myTeam.loading && myTeam.ssTeamId !== undefined && myTeam.ssTeamId !== null && myTeam.ssTeamId >= 0">
            <div class="card">
                <h2 class="p-text-left">Haberler</h2>
                <Carousel v-if="myTeam.newsList !== undefined && myTeam.newsList !== null && myTeam.newsList.length > 0"
                    :value="myTeam.newsList" :numScroll="4" :numVisible="5" :responsiveOptions="carouselResponsiveOptions">
                    <template #item="slotProps">
                        <div class="carousel-item">
                            <div class="carousel-item-content">
                                <div class="carousel-image-container mb-3">
                                    <img class="carousel-image" :src="slotProps.data.img_url" :alt="slotProps.data.title" />
                                </div>
                                <div class="p-pl-1 p-pr-1 p-text-left">
                                    <h5 class="mb-1">{{slotProps.data.carousel.title}}</h5>
                                    <h5 class="mt-0 mb-3 p-text-normal">${{slotProps.data.carousel.subtitle}}</h5>
                                    <div class="p-text-normal">
                                        <p align="right" style="font-size:0.8rem;">
                                            <span class="p-text-left"
                                                v-if="slotProps.data.has_pictures && slotProps.data.pictures !== undefined && slotProps.data.pictures !== null">
                                                ({{slotProps.data.pictures.length}} foto)
                                            </span>
                                            <span class="p-text-right">
                                                {{slotProps.data.carousel.news_date}}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="p-text-right">
                                    <Button icon="pi pi-search" label="Details" class="p-button-secondary p-button-text p-button-sm"
                                        @click="popupNewsDetails(slotProps.data)" />
                                </div>
                            </div>
                        </div>
                    </template>
                </Carousel>
                <p v-else>
                    News not found for this team.
                </p>
            </div>

            <div v-if="myTeam.data !== undefined && myTeam.data !== null &&
                myTeam.data.announcement !== undefined && myTeam.data.announcement !== null && myTeam.data.announcement.length > 0">
                <div class="card p-mt-0 p-text-left" v-for="(item) in myTeam.data.announcement" :key="item.t">
                    <h4 class="p-text-center" v-show="item.t !== undefined && item.t !== null">
                        {{item.t}}
                    </h4>

                    <p>{{item.d}}</p>

                    <p v-show="item.ty !== undefined && item.ty !== null">Type: {{item.ty}}</p>
                    <p v-show="item.i !== undefined && item.i !== null">Icon: {{item.i}}</p>
                    <p v-show="item.b !== undefined && item.b !== null">Button Text: {{item.b}}</p>
                    <p v-show="item.tr !== undefined && item.tr !== null">Button Target: {{item.tr}}</p>
                </div>
                <p align="right">
                    Announcements last update: {{ myTeam.data.announcement_update_date }}
                </p>
            </div>

            <div v-if="myTeam.data !== undefined && myTeam.data !== null &&
                myTeam.data.ss_next_event_id !== undefined && myTeam.data.ss_next_event_id !== null">
                <div class="card p-mt-0 p-text-left">
                    <h4>SS Next Event Id: {{ myTeam.data.ss_next_event_id }}</h4>
                </div>

                <p align="right">
                    SS Next Event last update: {{ myTeam.data.ss_next_event_id_update_date }}
                </p>
            </div>
            
            <div v-if="myTeam.data !== undefined && myTeam.data !== null &&
                myTeam.data.performance_chart !== undefined && myTeam.data.performance_chart !== null">
                <h2 class="p-text-left">Performans</h2>
                <Chart type="line" :data="myTeam.data.performance_chart" :options="lineChartOptions"></Chart>

                <p align="right">
                    Performance last update: {{ myTeam.data.performance_update_date }}
                </p>
            </div>

            <div v-if="myTeam.data !== undefined && myTeam.data !== null &&
                myTeam.data.standings !== undefined && myTeam.data.standings !== null">
                <h2 class="p-text-left">Sıralama</h2>

                <div class="card">
                    <div class="p-grid p-text-bold">
                        <div class="p-col-2">
                            Position
                        </div>
                        <div class="p-col-4 p-text-left">
                            Team
                        </div>
                        <div class="p-col-3">
                            Win / Drow / Loss
                        </div>
                        <div class="p-col-1">
                            Average
                        </div>
                        <div class="p-col-2">
                            Points
                        </div>
                    </div>
                    <div class="p-grid p-mt-0" v-for="(item) in myTeam.data.standings" :key="item.tid"
                        :class="item.tid === myTeam.ssTeamId ? 'current-team' : ''">
                        <div class="p-col-2">
                            {{item.ps}}
                        </div>
                        <div class="p-col-4 p-text-left">
                            {{item.n}}
                        </div>
                        <div class="p-col-3">
                            {{`${item.w} / ${item.d} / ${item.l}`}}
                        </div>
                        <div class="p-col-1">
                            {{item.sf - item.sa}}
                        </div>
                        <div class="p-col-2">
                            {{item.pt}}
                        </div>
                    </div>
                </div>

                <p align="right">
                    Standings last update: {{ myTeam.data.standings_update_date }}
                </p>
            </div>

            <div v-if="myTeam.data !== undefined && myTeam.data !== null &&
                myTeam.data.top_players !== undefined && myTeam.data.top_players !== null">
                <h2 class="p-text-left">Oyuncu istatistikleri</h2>

                <div class="p-grid">
                    <div class="p-col-6 p-md-4 p-p-1" v-for="(player, index) in myTeam.data.top_players" :key="index">
                        <div class="card">
                            <h4 class="p-text-left">{{player.title}}</h4>
                            <h3>{{player.n}}</h3>
                            <h3>{{player.v}}</h3>
                        </div>
                    </div>
                </div>

                <p align="right">
                    Top players last update: {{ myTeam.data.top_players_update_date }}
                </p>
            </div>
        </div>
    </div>

    <!-- news details popup -->
    <Dialog v-model:visible="popupNews.visible" header="Haber detayı"
        :modal="true" class="p-fluid p-col-10">
        <div class="p-grid">
            <div class="p-col-12 p-md-3">
                <img class="p-mt-2" :src="popupNews.item.img_url" style="max-width:90%;" />
                <div class="p-text-left" v-if="popupNews.item.date !== undefined && popupNews.item.date !== null">
                    <span class="p-text-bold" style="font-size: 0.9rem;">
                        #{{popupNews.item.id}}
                    </span>
                    <p class="news-details-date-value" style="color:lightgray">
                        Haber: <span class="p-text-bold" style="float:right">{{popupNews.item.news_date}}</span>
                    </p>
                    <p class="news-details-date-value" style="color:gray">
                        <span v-if="popupNews.item.last_updated_date !== undefined && popupNews.item.last_updated_date !== null
                            && popupNews.item.last_updated_date !== popupNews.item.date">
                            Güncelleme: <span style="float:right">{{popupNews.item.last_updated_date}}</span>
                        </span>
                        <span v-else>
                            Eklenme: <span style="float:right">{{popupNews.item.date}}</span>
                        </span>
                    </p>
                    <p class="news-details-date-value" v-if="popupNews.item.added_automatically" style="color:gray">
                        <span v-if="popupNews.item.news_details_saved_date !== undefined && popupNews.item.news_details_saved_date !== null">
                            Detay: <span style="float:right">{{popupNews.item.news_details_saved_date}}</span>
                        </span>
                        <span v-if="popupNews.item.source !== undefined && popupNews.item.source !== null">
                            <br/>
                            Kaynak: <span class="p-text-bold" style="float:right;">{{popupNews.item.source.toUpperCase()}}</span>
                        </span>
                    </p>
                </div>
                <p class="p-text-left p-text-bold" style="color:#ffc700"
                    v-show="(popupNews.item.teams !== null && popupNews.item.teams !== undefined && popupNews.item.teams.length > 0)">
                    {{popupNews.item.teams}}
                </p>
                <div class="p-text-left">
                    {{ popupNews.item.has_pictures ? 'Foto galeri (' + popupNews.item.pictures?.length + ')' : '' }}
                    <br/>
                    <a :href="popupNews.item.video_url"
                        target="_blank"
                        v-show="(popupNews.item.video_url !== null && popupNews.item.video_url !== undefined && popupNews.item.video_url.length > 0)">Video haber</a>
                </div>
            </div>
            <div class="p-col-12 p-md-9 p-text-left p-pl-4">
                <div id="news_content_container" style="overflow: hidden;">
                    <h2>{{popupNews.item.title}}</h2>
                    <p class="p-text-bold">
                        {{popupNews.item.subtitle}}
                    </p>
                    <p class="p-text-light"
                        v-html="popupNews.item.content"
                        id="news_content"
                        :ref="'news_content_'+popupNews.item.id">
                    </p>
                </div>
                <div v-if="popupNews.item.pictures !== undefined && popupNews.item.pictures !== null && popupNews.item.pictures.length > 0">
                    <Galleria :value="popupNews.item.pictures" :responsiveOptions="newsThumbnailsResponsiveOptions" :numVisible="5">
                        <template #item="picture">
                            <img :src="picture.item.img_url" :alt="picture.item.description"
                                v-tooltip.top="picture.item.description"
                                class="news-gallery-preview" />
                        </template>
                        <template #thumbnail="picture">
                            <img :src="picture.item.img_url" :title="picture.item.description"
                                :alt="picture.item.description"
                                v-tooltip.bottom="picture.item.description"
                                class="news-gallery-thumbnail" />
                        </template>
                    </Galleria>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<style>
.current-team {
    background: #66666622;
    border-radius: 10px;
}

.news-details-date-value {
    margin: 0px;
    padding: 0px;
}

.news-gallery-thumbnail {
    max-width: 120px;
    max-height: 120px;
}

.news-gallery-preview {
    max-width: 480px;
    max-height: 480px;
}

.carousel-item-content {
    border: 1px solid var(--surface-border);
    border-radius: 3px;
    margin: .3rem;
    text-align: center;
    padding: 2rem 0;
}

.carousel-image-container {
    height: 100px;
}

.carousel-image {
    max-width: 70%;
    max-height: 100px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}
</style>

<script>
import Dropdown from 'primevue/dropdown'
import Carousel from 'primevue/carousel'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Galleria from 'primevue/galleria'
import Chart from 'primevue/chart'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import dayjs from 'dayjs'
require('dayjs/locale/tr')

export default {
    name: 'My Team View',
    components: {
        Dropdown, Carousel, Button, Dialog, Galleria, Chart
    },
    data() {
        return {
            teams: {
                items: [],
                loading: false
            },
            myTeam: {
                ssTeamId: null,
                data: null,
                newsList: [],
                loading: false
            },
            carouselResponsiveOptions: [{
                breakpoint: '1024px',
                numVisible: 4,
                numScroll: 3
            }, {
                breakpoint: '600px',
                numVisible: 3,
                numScroll: 2
            }, {
                breakpoint: '480px',
                numVisible: 1,
                numScroll: 1
            }],
            popupNews: {
                item: null,
                visible: false
            },
            lineChartOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#DDDDDD'
                        },
                        grid: {
                            color: null
                        }
                    },
                    y: {
                        ticks: {
                            color: '#DDDDDD',
                            callback: function(value, index, ticks) {
                                if(value === 1) {
                                    return 'Galibiyet'
                                } else if(value === 0) {
                                    return 'Beraberlik'
                                } else if(value === -1) {
                                    return 'Mağlubiyet'
                                } else if(value === 4) {
                                    return index + ticks
                                } else {
                                    return '';
                                }
                            }
                        },
                        grid: {
                            color: null
                        }
                    }
                }
            }
        }
    },
    emits: ['loginResult', 'pageLoaded'],
    beforeMount() {
        this.$emit('pageLoaded', {
            title: 'My Team View'
        })
    },
    mounted() {
        this.getTeamList()
    },
    methods: {
        async getTeamList() {
            let self = this,
                cookies = self.$cookies,
                teams = self.teams,
                toast = self.$toast,
                token = cookies.get('token');
            
            try {
                teams.loading = true

                let response = await self.$http.get(`api/tournaments/${Const.TournamentIds.SuperLig}/teams`, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    teams.items = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Getting team list failed', detail: response.data.mesaj, life: 3000});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            } finally {
                teams.loading = false
            }
        },
        async getMyTeamData() {
            let self = this,
                cookies = self.$cookies,
                myTeam = self.myTeam,
                ssTeamId = self.myTeam.ssTeamId,
                toast = self.$toast,
                toastMessage = null,
                token = cookies.get('token');
            
            if(ssTeamId === undefined || ssTeamId === null) {
                toastMessage = 'Team not selected!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                myTeam.loading = true

                // get myteam data
                let response = await self.$http.get(`api/myteam/${ssTeamId}`, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    myTeam.data = response.data.item

                    if(myTeam.data.announcement_update_date !== undefined && myTeam.data.announcement_update_date !== null) {
                        myTeam.data.announcement_update_date = dayjs(new Date(myTeam.data.announcement_update_date)).format('DD/MM/YYYY HH:mm:ss');
                    }

                    if(myTeam.data.ss_next_event_id_update_date !== undefined && myTeam.data.ss_next_event_id_update_date !== null) {
                        myTeam.data.ss_next_event_id_update_date = dayjs(new Date(myTeam.data.ss_next_event_id_update_date)).format('DD/MM/YYYY HH:mm:ss');
                    }

                    if(myTeam.data.performance !== undefined && myTeam.data.performance !== null) {
                        myTeam.data.performance_chart = self.generatePerformanceChart(myTeam.data.performance)
                    }
                    
                    if(myTeam.data.performance_update_date !== undefined && myTeam.data.performance_update_date !== null) {
                        myTeam.data.performance_update_date = dayjs(new Date(myTeam.data.performance_update_date)).format('DD/MM/YYYY HH:mm:ss');
                    }

                    if(myTeam.data.standings_update_date !== undefined && myTeam.data.standings_update_date !== null) {
                        myTeam.data.standings_update_date = dayjs(new Date(myTeam.data.standings_update_date)).format('DD/MM/YYYY HH:mm:ss');
                    }

                    if(myTeam.data.top_players !== undefined && myTeam.data.top_players !== null) {
                        myTeam.data.top_players = self.generateTopPlayers(myTeam.data.top_players)
                    }

                    if(myTeam.data.top_players_update_date !== undefined && myTeam.data.top_players_update_date !== null) {
                        myTeam.data.top_players_update_date = dayjs(new Date(myTeam.data.top_players_update_date)).format('DD/MM/YYYY HH:mm:ss');
                    }
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                    return
                } else {
                    throw response.data.mesaj
                }

                // get news list
                response = await self.$http.get(`api/myteam/${ssTeamId}/news`, {
                    params: {
                        limit: 2,
                    },
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);

                    myTeam.newsList = response.data.items
                    myTeam.newsList.forEach((item, index) => {
                        myTeam.newsList[index] = self.prepareNewsItem(item)
                    })
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                    return
                } else {
                    throw response.data.mesaj
                }
            } catch(error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            } finally {
                console.log(myTeam)
                myTeam.loading = false
            }
        },
        prepareNewsItem(news) {
            let item = news
            item.date = dayjs(item.log_date).format('DD/MM/YYYY HH:mm:ss');
            
            if(item.last_updated_date !== undefined && item.last_updated_date !== null) {
                item.last_updated_date = dayjs(new Date(item.last_updated_date)).format('DD/MM/YYYY HH:mm:ss');
            }

            if(item.news_details_saved_date !== undefined && item.news_details_saved_date !== null) {
                item.news_details_saved_date = dayjs(new Date(item.news_details_saved_date)).format('DD/MM/YYYY HH:mm:ss');
            }

            let newsDate = item.news_date
            if(newsDate !== undefined && newsDate !== null) {
                item.news_date = dayjs(new Date(newsDate)).format('DD/MM/YYYY HH:mm:ss');
            }
            
            let teams = ""
            let mSelectedTeams = []
            if (!isEmpty(item.team1)) {
                teams += item.team1;
                mSelectedTeams.push({ss_team_id: item.ss_team_id, name: item.team1})
            
                if (!isEmpty(item.team2)) {
                    teams += ', ';
                }
            }
            if (!isEmpty(item.team2)) {
                teams += item.team2;
                mSelectedTeams.push({ss_team_id: item.ss_team_id_2, name: item.team2})
            }
            item.newsId = item.id
            item.selectedTeams = mSelectedTeams
            item.teams = teams

            item.carousel = {
                title: item.title.substr(0, 42) + (item.title.length > 42 ? '\u2026' : ''),
                subtitle: (item.subtitle !== undefined && item.subtitle !== null) ?
                    item.subtitle.substr(0, 60) + (item.subtitle.length > 60 ? '\u2026' : '') : null,
                news_date: newsDate
            }

            if(newsDate !== undefined && newsDate !== null) {
                item.carousel.news_date = dayjs(new Date(newsDate)).locale('tr').format('DD MMM ddd, HH:mm');
            }

            return item
        },
        popupNewsDetails(news) {
            this.popupNews.item = news
            this.popupNews.visible = true
        },
        generatePerformanceChart(performance) {
            let data = {
                labels: [],
                datasets: [{
                    label: 'Performans',
                    data: [],
                    borderColor: '#42A5F5',
                    tension: 0.1
                }]
            }

            performance.forEach(item => {
                let key = Object.keys(item)[0]
                let value = item[key]

                let labelKey = Object.keys(value)[0]
                let labelValue = value[labelKey]
                
                data.labels.push(`${labelKey} | ${labelValue}`)
                data.datasets[0].data.push(key)
            })

            return data
        },
        generateTopPlayers(topPlayers) {
            let players = []
            topPlayers.forEach(item => {
                let playerId = Object.keys(item)[0]
                let values = item[playerId]

                let newItem = {}
                newItem.playerId = playerId
                
                Object.keys(values).forEach(valueKey => {
                    newItem[valueKey] = values[valueKey]
                })


                switch(newItem['t']) {
                    case 'g': newItem['title'] = 'En çok gol atan'; break;
                    case 'a': newItem['title'] = 'En çok asist yapan'; break;
                    case 'sf': newItem['title'] = 'Gol sıklığı en yüksek'; break;
                    case 'ap': newItem['title'] = 'İsabetli pas (maç başı)'; break;
                    case 'yc': newItem['title'] = 'Sarı kart'; break;
                    case 'rc': newItem['title'] = 'Kırmızı kart'; break;
                    default: break;
                }

                players.push(newItem)
            })

            return players
        }
    }
}
</script>